import {CommonModule} from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {CoreModule} from '../../common/service/core/core.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule, CoreModule],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class ApiModule {}
